'use client'
import { queryKeys } from '@/shared/api/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from '@/shared/ui/use-toast'
import services from '../services'
import { CreateHypothesis, hypothesisMappers } from '../../lib'
import { CreateHypothesisParams } from '@/shared/api/end-points/hypothesis'

const useHook = (params: { refetchQueryKeys?: string[]; queryParams: CreateHypothesisParams }) => {
  const queryClient = useQueryClient()
  const mutationKey = [queryKeys((a, m, p) => a.hypothesis.create + m.get)]

  const mutaion = useMutation({
    mutationKey,
    mutationFn: async (payload: Partial<CreateHypothesis>) => {
      const mappedPayload = hypothesisMappers.mapCreateHypothesisToDto(payload)
      await services.create(mappedPayload, params.queryParams)
    },
    onSuccess: () => {
      toast({
        title: 'Вы успешно создали гипотезу!',
      })

      if (!params?.refetchQueryKeys) return null
      queryClient.refetchQueries({
        queryKey: params.refetchQueryKeys,
      })
    },
  })

  useEffect(() => {
    if (mutaion.isError) console.error(mutaion.error)
  }, [mutaion.error, mutaion.isError])

  const muationResult = {
    ...mutaion,
  }

  return muationResult
}

export default useHook
